import Vue from "vue";
import VueRouter from "vue-router";
import {AppConsts} from "cf/packages/abpVue/AppConsts";
import Mobile from "@/assets/Mobile.js";
import l from "cf/packages/abpVue/utils/abp.localization.js";
import AppPreBootstrap from 'cf/packages/abpVue/AppPreBootstrap'

Vue.use(VueRouter);

var emptyCom = {template: "<router-view></router-view>"};

var routes = [
  {
    path: "/Login",
    name: "Login",
    component: () => import("@/mobile/account/login.vue"),
    meta: {display: "登录", lKey: "DENGLU", hidden: true}
  },
  {
    path: "/Register",
    name: "Register",
    component: () => import("@/mobile/account/register.vue"),
    meta: {display: "注册", lKey: "ZHUCE", hidden: true}
  },
  {
    path: "/YunLogin",
    name: "YunLogin",
    component: () => import("@/mobile/account/yunLogin.vue"),
    meta: {display: "云之家", lKey: "YUNZHIJIA", hidden: true}
  },
  {
    path: "/fwoaLogin",
    name: "fwoaLogin",
    component: () => import("@/mobile/account/fwoaLogin.vue"),
    meta: {display: "泛微OA", lKey: "FANWEIOA", hidden: true}
  },
  {
    path: "/DingTalkLogin",
    name: "DingTalkLogin",
    component: () => import("@/mobile/account/ddLogin.vue"),
    meta: {display: "钉钉", lKey: "DINGDING", hidden: true}
  },
  {
    path: "/rsaLogin",
    name: "rsaLogin",
    component: () => import("@/mobile/account/rsaLogin.vue"),
    meta: {display: "单点登录", lKey: "DANDIANDENGLU", hidden: true}
  },
  {
    path: "/WxLogin",
    name: "WxLogin",
    component: () => import("@/mobile/account/wxLogin.vue"),
    meta: {display: "微信", lKey: "WEIXIN", hidden: true}
  },
  {
    path: "/WxOutLogin",
    name: "WxOutLogin",
    component: () => import("@/mobile/wechat/outLogin.vue"),
    meta: {display: "微信", lKey: "WEIXIN", hidden: true}
  },
  {
    path: "/",
    name: "Home",
    component: () => import("@/mobile/home/home.vue"),
    meta: {display: "首页", lKey: "SHOUYE", hidden: true, requiresAuth: true}
  },
  {
    path: "/HomeCustomized",
    name: "HomeCustomized",
    component: () => import("@/mobile/homeCustomized/home.vue"),
    meta: {display: "首页", lKey: "SHOUYE", hidden: true, requiresAuth: true}
  },
  {
    path: "/gengduoList",
    name: "gengduoList",
    component: () => import("@/mobile/homeCustomized/list/gengduoList.vue"),
    meta: {display: "首页", lKey: "SHOUYE", hidden: true, requiresAuth: true}
  },
  {
    path: "/UserInfo",
    name: "UserInfo",
    component: () => import("@/mobile/userInfo/userInfo.vue"),
    meta: {
      display: "个人信息修改",
      lKey: "GERENXINXIXIUGAI",
      hidden: true,
      requiresAuth: true
    }
  },
  {
    path: "/Guest",
    name: "Guest",
    component: () => import("@/mobile/guest/home/home.vue"),
    meta: {display: "首页", lKey: "SHOUYE", hidden: true}
  },
  {
    path: "/GuestCourse",
    name: "GuestCourse",
    component: () => import("@/mobile/guest/course/course.vue"),
    meta: {display: "课程详情", lKey: "KECHENGXIANGQING", hidden: true}
  },
  {
    path: "/GuestCourseware",
    name: "GuestCourseware",
    component: () => import("@/mobile/guest/course/courseware.vue"),
    meta: {display: "课件详情", lKey: "KEJIANXIANGQING", hidden: true}
  },
  {
    path: "/CourseList",
    name: "CourseList",
    component: () => import("@/mobile/course/courseList.vue"),
    meta: {
      hidden: true,
      requiresAuth: true,
      type: "ONLINE",
      display: "课程中心",
      lKey: "KECHENGZHONGXIN",
      searchType: "COURSE"
    }
  },
  {
    path: "/CourseListByType",
    name: "CourseListByType",
    component: () => import("@/mobile/course/courseListByType.vue"),
    meta: {
      hidden: true,
      requiresAuth: true,
      type: "ONLINE",
      display: "课程中心",
      lKey: "KECHENGZHONGXIN",
      searchType: "COURSE"
    }
  },
  {
    path: "/MyCourseList",
    name: "MyCourseList",
    component: () => import("@/mobile/course/myCourseList.vue"),
    meta: {
      display: "我的课程",
      requiresAuth: true,
      type: "ONLINE",
      lKey: "WODEKECHENG",
      searchType: "COURSE"
    }
  },
  {
    path: "/MyCourseList31",
    name: "MyCourseList31",
    component: () => import("@/mobile/course/sany/myCourseList.vue"),
    meta: {
      display: "我的课程",
      requiresAuth: true,
      type: "ONLINE",
      lKey: "WODEKECHENG",
      searchType: "COURSE"
    }
  },
  {
    path: "/CoursePackageList",
    name: "CoursePackageList",
    component: () => import("@/mobile/course/coursePackageList.js"),
    meta: {
      hidden: true,
      requiresAuth: true,
      type: "PACKAGE",
      display: "系列课程",
      lKey: "XILIEKECHENG",
      searchType: "COURSE"
    }
  },
  {
    path: "/MyCoursePackageList",
    name: "MyCoursePackageList",
    component: () => import("@/mobile/course/myCoursePackageList.js"),
    meta: {
      display: "我的系列课程",
      requiresAuth: true,
      type: "PACKAGE",
      lKey: "WODEXILIEKECHENG",
      searchType: "COURSE"
    }
  },
  {
    path: "/MyCoursePackageList31",
    name: "MyCoursePackageList31",
    component: () => import("@/mobile/course/sany/myCoursePackageList.js"),
    meta: {
      display: "我的系列课程",
      requiresAuth: true,
      type: "PACKAGE",
      lKey: "WODEXILIEKECHENG",
      searchType: "COURSE"
    }
  },
  {
    path: "/Course/:id",
    name: "Course",
    component: () => import("@/mobile/course/v2/course.vue"),
    meta: {
      display: "课程详情",
      lKey: "KECHENGXIANGQING",
      requiresAuth: true
    },
    children: [
      {
        path: ":coursewareId",
        name: "CCourseware",
        component: () => import("@/mobile/course/courseware.vue"),
        meta: {
          display: "课程详情",
          lKey: "KECHENGXIANGQING",
          requiresAuth: true
        },
      }
    ]
  },
  {
    path: "/Courseware",
    name: "Courseware",
    component: () => import("@/mobile/course/courseware.vue"),
    meta: {
      display: "课程详情",
      lKey: "KECHENGXIANGQING",
      requiresAuth: true
    }
  },
  {
    path: "/MyExamList",
    name: "MyExamList",
    component: () => import("@/mobile/exam/myExamList.vue"),
    meta: {
      display: "我的考试",
      lKey: "WODEKAOSHI",
      requiresAuth: true,
      searchType: "EXAM"
    }
  },
  {
    path: "/MyExamSimulateList",
    name: "MyExamSimulateList",
    component: () => import("@/mobile/exam/MyExamSimulateList.vue"),
    meta: {
      display: "模拟自考",
      lKey: "MONIZIKAO",
      requiresAuth: true,
      searchType: "EXAM"
    }
  },
  {
    path: "/MySimulateList",
    name: "MySimulateList",
    component: () => import("@/mobile/exam/mySimulateList.vue"),
    meta: {
      display: "模拟考试",
      lKey: "MONIKAOSHI",
      requiresAuth: true,
      searchType: "EXAM"
    }
  },
  {
    path: "/SimulateExam",
    name: "SimulateExam",
    component: () => import("@/mobile/exam/simulateExam.vue"),
    meta: {display: "考试详情", lKey: "KAOSHIXIANGQING", requiresAuth: true}
  },
  {
    path: "/Exam",
    name: "Exam",
    component: () => import("@/mobile/exam/exam.vue"),
    meta: {display: "考试详情", lKey: "KAOSHIXIANGQING", requiresAuth: true}
  },
  {
    path: "/Paper",
    name: "Paper",
    component: () => import("@/mobile/exam/paper.vue"),
    meta: {display: "考试试卷详情", lKey: "SHIJUANXIANGQING", requiresAuth: true}
  },

  {
    path: "/SimulatePaper",
    name: "SimulatePaper",
    component: () => import("@/mobile/exam/simulatePaper.vue"),
    meta: {display: "考试试卷详情", lKey: "SHIJUANXIANGQING", requiresAuth: true}
  },

  {
    path: "/PaperRecord",
    name: "PaperRecord",
    component: () => import("@/mobile/exam/paperRecord.vue"),
    meta: {display: "试卷结果", lKey: "SHIJUANJIEGUO", requiresAuth: true}
  },
  {
    path: "/SimulatePaperRecord",
    name: "SimulatePaperRecord",
    component: () => import("@/mobile/exam/simulatePaperRecord.vue"),
    meta: {display: "试卷结果", lKey: "SHIJUANJIEGUO", requiresAuth: true}
  },
  {
    path: "/TrainList",
    name: "TrainList",
    component: () => import("@/mobile/train/trainList.vue"),
    meta: {
      display: "公开班级",
      lKey: "GONGKAIBANJI",
      requiresAuth: true,
      searchType: "TRAIN"
    }
  },
  {
    path: "/MyTrainList",
    name: "MyTrainList",
    component: () => import("@/mobile/train/myTrainList.vue"),
    meta: {
      display: "我的班级",
      lKey: "WODEBANJI",
      requiresAuth: true,
      searchType: "TRAIN"
    }
  },
  {
    path: "/Train",
    name: "Train",
    component: () => import("@/mobile/train/train.vue"),
    meta: {display: "班级详情", lKey: "BANJIXIANGQING", requiresAuth: true}
  },
  {
    path: "/TrainPaper",
    name: "TrainPaper",
    component: () => import("@/mobile/train/trainPaper.vue"),
    meta: {display: "评估调研", lKey: "PINGGUDIAOYAN", requiresAuth: true}
  },
  {
    path: "/TrainUnityPaper",
    name: "TrainUnityPaper",
    component: () => import("@/mobile/train/trainUnityPaper.vue"),
    meta: {display: "评估调研", lKey: "PINGGUDIAOYAN", requiresAuth: true}
  },
  {
    path: "/OutSurveyPaper",
    name: "OutSurveyPaper",
    component: () => import("@/mobile/outSurvey/paper.vue"),
    meta: {display: "外部调研", lKey: "WAIBUDIAOCHA", hidden: true, requiresOutAuth: true}
  },
  {
    path: "/DocList",
    name: "DocList",
    component: () => import("@/mobile/doc/docList.vue"),
    meta: {
      display: "文库中心",
      lKey: "WENKUZHOGNXIN",
      requiresAuth: true,
      searchType: "DOC"
    }
  },
  {
    path: "/DocList31",
    name: "DocList31",
    component: () => import("@/mobile/doc/sany/docList.vue"),
    meta: {
      display: "文库中心",
      lKey: "WENKUZHOGNXIN",
      requiresAuth: true,
      searchType: "DOC"
    }
  },
  {
    path: "/DocDetail",
    name: "DocDetail",
    component: () => import("@/mobile/doc/docDetail.vue"),
    meta: {display: "文库详情", lKey: "WENKUXIANGQING", requiresAuth: true}
  },
  {
    path: "/GuestDocDetail",
    name: "GuestDocDetail",
    component: () => import("@/mobile/guest/doc/docDetail.vue"),
    meta: {display: "文库详情", lKey: "WENKUXIANGQING"}
  },
  {
    path: "/Message",
    name: "Message",
    component: () => import("@/mobile/guest/message/message.vue"),
    meta: {display: "留言", lKey: "LIUYAN"}
  },
  {
    path: "/BBSList",
    name: "BBSList",
    component: () => import("@/mobile/bbs/bbsList.vue"),
    meta: {
      display: "互动交流",
      lKey: "HUDONGJIAOLIU",
      requiresAuth: true,
      searchType: "BBS"
    }
  },
  {
    path: "/BBS",
    name: "BBS",
    component: () => import("@/mobile/bbs/bbsDetail.vue"),
    meta: {display: "互动交流", lKey: "HUDONGJIAOLIU", requiresAuth: true}
  },
  {
    path: "/Search",
    name: "Search",
    component: () => import("@/mobile/search/searchResult.vue"),
    meta: {display: "搜索", lKey: "SOUSUO", requiresAuth: true}
  },
  {
    path: "/Notification",
    name: "Notification",
    component: () => import("@/mobile/notification/notificationList.vue"),
    meta: {display: "消息中心", lKey: "XIAOXIZHONGXIN", requiresAuth: true}
  },
  {
    path: "/signIn",
    name: "signIn",
    component: () => import("@/mobile/signIn/signIn.vue"),
    meta: {display: "签到", lKey: "QIANDAO", requiresAuth: true}
  },
  {
    path: "/shopping",
    name: "shopping",
    component: () => import("@/mobile/shopping/shopping.vue"),
    meta: {display: "积分商城", lKey: "JIFENSHANGCHENG", requiresAuth: true}
  },
  {
    path: "/shoppingInfo",
    name: "shoppingInfo",
    component: () => import("@/mobile/shopping/shoppingInfo.vue"),
    meta: {display: "商品详情", lKey: "JIFENSHANGCHENG", requiresAuth: true}
  },



  {
    path: "/integral",
    name: "integral",
    component: () => import("@/mobile/integral/integral.vue"),
    meta: {display: "学员积分排行", lKey: "JIFENPAIHANG", requiresAuth: true}
  },
  {
    path: "/creditList",
    name: "creditList",
    component: () => import("@/mobile/integral/creditList.vue"),
    meta: {display: "学员学分排行榜", lKey: "XUEFENPAIHANG", requiresAuth: true}
  },
  {
    path: "/classHourList",
    name: "classHourList",
    component: () => import("@/mobile/integral/classHourList.vue"),
    meta: {display: "学员课时排行", lKey: "KESHIPAIHANG", requiresAuth: true}
  },
  {
    path: "/lecturerList",
    name: "lecturerList",
    component: () => import("@/mobile/integral/lecturerList.vue"),
    meta: {display: "讲师课时排行", lKey: "JIANGSHIPAIHANG", requiresAuth: true}
  },




  {
    path: "/BuyHistory",
    name: "BuyHistory",
    component: () => import("@/mobile/buyHistory/buyHistory.vue"),
    meta: {display: "兑换记录", lKey: "DUIHUANJILU", requiresAuth: true}
  },
  {
    path: "/MySurveyList",
    name: "MySurveyList",
    component: () => import("@/mobile/survey/my_survey_list.vue"),
    meta: {display: "我的调研", lKey: "WODEDIAOYAN", requiresAuth: true}
  },
  {
    path: "/SpecialList",
    name: "SpecialList",
    component: () => import("@/mobile/special/specialList.vue"),
    meta: {display: "学习专栏", lKey: "XUEXIZHUANLAN", requiresAuth: true}
  },
  {
    path: "/Special",
    name: "Special",
    component: () => import("@/mobile/special/special.vue"),
    meta: {display: "资料详情", lKey: "ZILIAOXIANGQING", requiresAuth: true}
  },
  {
    path: "/ContractList",
    name: "ContractList",
    component: () => import("@/mobile/contractList/contractList.vue"),
    meta: {display: "通讯录", lKey: "TONGXUNLU", requiresAuth: true}
  },
  {
    path: "/Contract",
    name: "Contract",
    component: () => import("@/mobile/contractList/contract.vue"),
    meta: {display: "通讯录", lKey: "TONGXUNLU", requiresAuth: true}
  },
  {
    path: "/Ranking",
    name: "Ranking",
    component: () => import("@/mobile/ranking/ranking.vue"),
    meta: {display: "排行榜", lKey: "PAIHANGBANG", requiresAuth: true}
  },
  {
    path: "/FaultList",
    name: "FaultList",
    component: () => import("@/mobile/fault/faultList.vue"),
    meta: {display: "故障代码", lKey: "GUZHANGDAIMA", requiresAuth: true}
  },
  {
    path: "/ResourceCenter",
    name: "ResourceCenter",
    component: () => import("@/mobile/resourceCenter/resourceCenter.vue"),
    meta: {display: "资料中心", lKey: "ZILIAOZHONGXIN", requiresAuth: true}
  },
  {
    path: "/TvLiveList",
    name: "TvLiveList",
    component: () => import("@/mobile/tvLive/tvLiveList.vue"),
    meta: {display: "直播列表", lKey: "ZHIBOLIEBIAO", requiresAuth: true}
  },
  {
    path: "/TvLive",
    name: "TvLive",
    component: () => import("@/mobile/tvLive/tvLive.vue"),
    meta: {display: "直播详情", lKey: "ZHIBOXIANGQING", requiresAuth: true}
  },
  {
    path: "/TvLiveList_L",
    name: "TvLiveList_L",
    component: () => import("@/mobile/tvLive_L/tvLiveList.vue"),
    meta: {display: "直播列表", lKey: "ZHIBOLIEBIAO", requiresAuth: true}
  },
  {
    path: "/TvLive_L",
    name: "TvLive_L",
    component: () => import("@/mobile/tvLive_L/tvLive.vue"),
    meta: {display: "直播详情", lKey: "ZHIBOXIANGQING", requiresAuth: true}
  },
  {
    path: "/QrSign",
    name: "QrSign",
    component: () => import("@/mobile/qrSign/qrSign.vue"),
    meta: {display: "二维码", lKey: "ERWEIMA", requiresAuth: true}
  },
  {
    path: "/ActivitySign",
    name: "ActivitySign",
    component: () => import("@/mobile/activitySign/activitySign.vue"),
    meta: {display: "活动报名", lKey: "HUODONGBAOMING", requiresAuth: true}
  },
  {
    path: "/ActivityOutSign",
    name: "ActivityOutSign",
    component: () => import("@/mobile/activitySign/activitySign.vue"),
    meta: {display: "活动报名", lKey: "HUODONGBAOMING", requiresOutAuth: true}
  },
  {
    path: "/WorkflowNode",
    name: "WorkflowNode",
    component: () => import("@/mobile/workflow/WorkflowNode.vue"),
    meta: {display: "工作流审批", lKey: "GONGZUOLIUSHENPI", requiresAuth: true}
  },
  {
    path: "/TrainPlanList",
    name: "TrainPlanList",
    component: () => import("@/mobile/trainPlan/trainPlanList.vue"),
    meta: {display: "我的计划", lKey: "WODEJIHUA", requiresAuth: true}
  },
  {
    path: "/TrainPlan",
    name: "TrainPlan",
    component: () => import("@/mobile/trainPlan/trainPlan.vue"),
    meta: {display: "计划详情", lKey: "JIHUAXIANGQING", requiresAuth: true}
  },
  {
    path: "/StudentHistory",
    name: "StudentHistory",
    component: () => import("@/mobile/StudentHistory/studentHistory.vue"),
    meta: {display: "我的变动详情", lKey: "JIFENHUOQUXIANGQING", requiresAuth: true}
  },
  {
    path: "/MyCertificates",
    name: "MyCertificates",
    component: () => import("@/mobile/myCertificates/list.vue"),
    meta: {display: "我的证书", lKey: "WODEZHENGSHU", requiresAuth: true}
  },
  {
    path: "/MyCertificateInfo",
    name: "MyCertificateInfo",
    component: () => import("@/mobile/myCertificates/info.vue"),
    meta: {display: "我的证书", lKey: "WODEZHENGSHU", requiresAuth: true}
  },
];

//常用页面配置
routes = routes.concat([
  {
    path: "/redirect",
    component: () => import("@/pages/common/Redirect.vue"),
    meta: {
      hidden: true
    }
  },
  {
    path: "/500",
    component: () => import("@/pages/common/Page500.vue"),
    meta: {
      hidden: true
    }
  },
  {
    path: "*",
    component: () => import("@/pages/common/Page404.vue"),
    meta: {
      hidden: true
    }
  }
]);

const router = new VueRouter({
  // mode: 'history',
  routes: routes,
  linkActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  if (abp.auth.getToken() && to.matched.some(record => record.meta.requiresAuth)) {
    if (!abp.userInfo.id) {
      AppPreBootstrap.getUserConfiguration(() => {
        auth(to, from, next)
      })
    } else {
      auth(to, from, next)
    }
  } else {
    auth(to, from, next)
  }

  Mobile.setTitle(
    to.query.title || (to.meta.lKey ? l(to.meta.lKey) : to.meta.display)
  );
});

function auth(to, from, next) {
  if (to.matched.some(record => record.meta.requiresAuth)) {

    if (!abp.auth.getToken()) {
      if (AppConsts.debug) {
        next({
          path: "/Login",
          query: {redirect: to.fullPath},
          replace: true
        });
      } else if (Mobile.isYzjApp()) {
        next({
          path: "/YunLogin",
          query: {redirect: to.fullPath},
          replace: true
        });
      } else if (Mobile.isDD() && AppConsts.dingding_platform) {
        next({
          path: "/DingTalkLogin",
          query: {redirect: to.fullPath},
          replace: true
        });
      } else if (Mobile.isWxApp() && AppConsts.cp_wechat_platform) {
        var STATE = encodeURIComponent(
          window.location.origin +
          "/#/WxLogin?jwt={jwt}&redirect=" +
          to.fullPath
        );
        var REDIRECT_URI = encodeURIComponent(
          (AppConsts.remoteServiceBaseUrl.indexOf("http://") == 0
            ? AppConsts.remoteServiceBaseUrl
            : window.location.origin + AppConsts.remoteServiceBaseUrl) +
          "/wx/cp/portal/redirectApp"
        );

        window.location.replace(
          AppConsts.wechat.wechatAuthUrl
            .replace("{STATE}", STATE)
            .replace("{REDIRECT_URI}", REDIRECT_URI)
        );
        next(false);
      } else {
        next({
          path: "/Login",
          query: {redirect: to.fullPath},
          replace: true
        });
      }
    } else {
      next();
      if (Mobile.isYzjApp()) {
        Mobile.configShare();
      }
    }
  } else if (to.matched.some(record => record.meta.requiresOutAuth) && (AppConsts.wechat_platform || AppConsts.cp_wechat_platform) && !window.outAuth) {
    // var STATE = encodeURIComponent(
    //   window.location.origin +
    //   "/#/WxOutLogin?mobile={mobile}&name={name}&user={user}&redirect=" +
    //   to.fullPath
    // );

    var STATE = to.fullPath;

    var isCp = false;
    var ua = window.navigator.userAgent.toLowerCase();
    if ((ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
      isCp = true;
    } else if (ua.match(/micromessenger/i) == 'micromessenger') {
      isCp = false;
    }

    var REDIRECT_URI = encodeURIComponent(
      (AppConsts.remoteServiceBaseUrl.indexOf("http://") == 0
        ? AppConsts.remoteServiceBaseUrl
        : window.location.origin + AppConsts.remoteServiceBaseUrl) +
      (isCp && AppConsts.cp_wechat_platform ? "/wx/cp/portal/getWXUserInfo" : "/wx/mp/portal/getWXUserInfo")
    );

    window.location.replace(
      AppConsts.wechat.wechatAuthUrl
        .replace("{STATE}", encodeURIComponent(STATE))
        .replace("{REDIRECT_URI}", REDIRECT_URI)
    );
    next(false);
  } else {
    next();
  }
}

export default router;



// WEBPACK FOOTER //
// ./src/config/router/mobile.index.js